import classNames from 'classnames';
import { FC } from 'react';

type RibbleButtonProps = {
  name: string;
  onClick?: () => void;
  href?: string;
  target?: string;
  className?: string;
};

const RibbleButton: FC<RibbleButtonProps> = ({
  name,
  onClick,
  href,
  target = '_blank',
  className,
  ...props
}) => {
  const combinedClassNames = classNames('glow-animate-btn', className);

  return (
    <a
      className={combinedClassNames}
      target={target}
      rel="noopener noreferrer"
      type="button"
      {...(href && { href })}
      {...(onClick && { onClick })}
      {...props}
    >
      <span className="button-text">{name}</span>
      <span className="icon-circle">
        <i className="fa-light fa-arrow-up-right" />
      </span>
    </a>
  );
};

export default RibbleButton;
